<template>
  <div class="cardEventSkeleton">
    <div class="cardEventSkeleton__imageWrap">
      <div class="cardEventSkeleton__image skeletonLoading" />
    </div>

    <div class="cardEventSkeleton__content">
      <div class="flex-1">
        <div class="flex flex-col justify-between">
          <h2 class="cardEventSkeleton__titleTeams text-main text-body-medium skeletonLoading max-w-2/4" />
          <h2 class="cardEventSkeleton__titleTeams text-main text-body-medium skeletonLoading max-w-3/5" />
        </div>
        <div class="mt-3 flex justify-between">
          <p class="cardEventSkeleton__title skeletonLoading" />
          <div class="cardEventSkeleton__sportTypeIcon skeletonLoading" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.cardEventSkeleton {
  @apply flex flex-col max-w-full
  overflow-hidden cursor-wait
  transition duration-100
  hover:shadow-lg;

  background-color: var(--base-card-bgColor);
  border-radius: var(--base-border-radius);

  .cardEventSkeleton__content {
    @apply p-3 pt-4
    flex flex-col justify-between flex-1;
  }

  .cardEventSkeleton__titleTeams {
    @apply w-full h-6 mb-1 overflow-hidden;
  }

  .cardEventSkeleton__imageWrap {
    @apply relative m-3 mb-0 flex-shrink-0;
  }

  .cardEventSkeleton__image {
    @apply w-full min-h-[8rem];

    border-radius: var(--base-border-radius);
  }

  .cardEventSkeleton__title {
    @apply w-3/4 h-3;
  }

  .cardEventSkeleton__sportTypeIcon {
    @apply w-4 h-4 rounded-full;
  }
}
</style>
